import { SvgIcon } from '@mui/material';

export function Checked() {
  return (
    <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="8.5" fill="white" strokeWidth="7" />
    </SvgIcon>
  );
}
